
















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";

/* 
 * - PropertyEditorの形に合わせに縦方向に項目が並ぶようにする
 * - ラジオボタンのように動作するがチェックを外すことができる必要がある（入力不可に切り替えることができるもの）。
 */

@Component({
  components: {
  }
})
export default class InputMethodEditCheckBox extends Mixins(ModelEditableMixin) {
  @Prop()
  option: any;
  @Prop()
  unselection: any;

  get selected(): boolean {
    return this.option.value === this.editingSource;
  }

  set selected(value: boolean) {
    this.editingSource = this.newValue;
  }

  get newValue(): any {
    return (this.unselection != null && this.selected)
      ? this.unselection
      : this.option.value;
  }

  onClick(event: PointerEvent): void {
    if (this.editingSource === this.newValue) {
      event.preventDefault();
    }
  }
}
